import logger from 'loglevel';
import store, {StoreAPI} from 'store2';

import {AbstractStore} from 'models/AbstractStore';
import {RootStore} from 'models/RootStore';
import {IPermanentStore, PermanentStore} from 'models/PermanentStore';

export class LocalStoreWrapper extends AbstractStore implements IPermanentStore {
    private readonly _localStorage: StoreAPI;

    public constructor(rootStore: RootStore, databaseName: string, tableName: string) {
        super(rootStore, `LocalStore.${databaseName}.${tableName}`);
        this._localStorage = store.namespace(this.DatabaseName);
    }

    public doStore<T>(_ignored: string, key: string, value: T, expiresInMinutes?: number): Promise<void> {
        this._localStorage.set(key, JSON.stringify({
            data: value,
            expiresAt: PermanentStore.getExpiresAt(expiresInMinutes)
        }));

        return Promise.resolve();
    }

    public doRead<T>(_ignored: string, key: string): Promise<T | null> {
        let dataString: string | null = this._localStorage.get(key);

        if (!dataString) {
            return Promise.resolve(null);
        }

        let dataObject: { data: T, expiresAt: number } = JSON.parse(dataString);

        if (PermanentStore.hasExpired(dataObject.expiresAt)) {
            return Promise.resolve(null);
        }

        return Promise.resolve(dataObject.data);
    }

    public clear(): Promise<void> {
        this._localStorage.clear();
        return;
    }
}
